import { Stages } from "../actions/actions";
import { callGa, callGaEvent } from "../actions/services";

export const trackingMiddleware = (store) => (next) => (action) => {
  try {
    if (action.type == "SET_STAGE" || action.type == "LOGOUT") {
      let stages = Object.keys(Stages);
      let stageName = stages.find((s) => Stages[s] == action.stage);
      if (stageName) {
        let pageName = window.settings.ga.pages[stageName];
        callGa(pageName);
      }
    }

    if (action.type == "CALL_GA") {
      callGa(action.page, action.error);
    }

    if (action.type == "CALL_GA_EVENT") {
      callGaEvent(action.category, action.action, action.label);
    }
  } catch (e) {}
  return next(action);
};



// WEBPACK FOOTER //
// ./src/middlewares/tracking.js